// Module
var code = "<machines-pricing on-success=\"onSuccess\" on-error=\"onError\">\n";
// Exports
var _module_exports = code;;
var path = '/admin/pricing/machine_hours.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;